import { Popover, PopoverProps, RadioGroup, Stack } from "@mui/material";

import { DimensionsPreview } from "@/components/ui-v2/DimensionsPreview";
import { AspectRatio } from "@/types";

import { AspectRatioRadioItem } from "./AspectRatioRadioItem";

interface AspectRatioPickerProps {
  // Popover props
  open: PopoverProps["open"];
  onClose: PopoverProps["onClose"];
  anchorEl: PopoverProps["anchorEl"];
  anchorOrigin?: PopoverProps["anchorOrigin"];
  transformOrigin?: PopoverProps["transformOrigin"];

  // Aspect Ratio props
  aspectRatios: AspectRatio[];
  value: AspectRatio;
  onChange?: (value: AspectRatio) => void;
}

export const AspectRatioPicker = (props: AspectRatioPickerProps) => {
  const { aspectRatios, value, onChange, ...popoverProps } = props;

  return (
    <Popover {...popoverProps}>
      <Stack sx={{ width: 200 }}>
        <DimensionsPreview dimensions={[value.width, value.height]} />
        <Stack
          sx={{
            gap: 2,
          }}
        >
          <RadioGroup value={value.type}>
            {aspectRatios.map((aspectRatio) => (
              <AspectRatioRadioItem
                key={aspectRatio.type}
                aspectRatio={aspectRatio}
                onChange={onChange || (() => {})}
              />
            ))}
          </RadioGroup>
        </Stack>
      </Stack>
    </Popover>
  );
};
